import React from "react";
import { Button } from "@mui/material";
import { useFormik } from "formik";
import { Grid, Box, } from "@mui/material";
import PositionFormFields from "./PositionFormFields";
import TabComponent from "components-base/Tab/Tab";
import { createPosition, modifyPosition, validationSchemaPosition } from "../functions";
import { useDispatch, useSelector } from "react-redux";
import { showMessage } from "store/modules/Message";

const PositionForm = ({ mode, handleClose }) => {
    const { defaultDataPosition } = useSelector(({ position }) => position);
    const dispatch = useDispatch();
    const messages = (mensaje) => {
        dispatch(
            showMessage({
                message: `Posicion ${mensaje} con éxito`,
                variant: "success",
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "right",
                },
            })
        );

    }
    const formik = useFormik({
        initialValues:
            mode === "POST"
                ? {
                    name: "",
                    description: "",
                    code: "",
                }
                : {
                    id: defaultDataPosition?.id,
                    name: defaultDataPosition?.name,
                    description: defaultDataPosition?.description,
                    code: defaultDataPosition?.code,
                },
        validationSchema: validationSchemaPosition,
        onSubmit: async (values) => {
            switch (mode) {
                case "POST":
                    await createPosition(values, dispatch);
                    messages("Creado")
                    handleClose();
                    break;
                case "PUT":
                    await modifyPosition(values, dispatch);
                    messages("Modificado");
                    handleClose();
                    break;
                default: handleClose();
            }
        },
    },);
    const { setFieldValue } = formik;

    return (
        <Box
            component="form"
            onSubmit={formik.handleSubmit}
            sx={{
                "& .MuiTextField-root": { marginBottom: "25px" },
            }}
            style={{ padding: "20px", justifyContent: "center" }}
        >
            <TabComponent tabsElement={[
                {
                    label: "Información de Posicion",
                    component: <PositionFormFields formik={formik} mode={mode} setFieldValue={setFieldValue} />
                }
            ]} />
            <Grid container
                spacing={2}
                sx={{ display: "flex", justifyContent: "flex-end", padding: 0 }}
            >
                <Grid item sx={12} >
                    <Button onClick={handleClose} color="primary" variant="contained">
                        Cancelar
                    </Button>
                </Grid>
                <Grid item sx={12}>
                    <Button color="primary" variant="contained" type="submit">
                        Guardar
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
}
export default PositionForm;